// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.js";
import * as Store from "./store/Store.bs.js";
import * as React from "react";
import * as AppStore from "./store/AppStore.bs.js";
import * as ReactDom from "react-dom";
import * as ServiceWorker from "./serviceWorker";

import "./styles/index.sass"
;

function unregister(prim) {
  ServiceWorker.unregister();
  
}

function register(prim) {
  ServiceWorker.register();
  
}

var ServiceWorker$1 = {
  unregister: unregister,
  register: register
};

var StrictMode = {};

function Root$ReactApp(Props) {
  var match = React.useReducer(AppStore.reducer, AppStore.initialState);
  return React.createElement(React.StrictMode, {
              children: React.createElement(Store.DispatchProvider.make, {
                    value: match[1],
                    children: React.createElement(Store.StateProvider.make, {
                          value: match[0],
                          children: React.createElement(App.make, {})
                        })
                  })
            });
}

var ReactApp = {
  make: Root$ReactApp
};

var root = document.querySelector("#root");

if (!(root == null)) {
  ReactDom.render(React.createElement(Root$ReactApp, {}), root);
}

ServiceWorker.unregister();

export {
  ServiceWorker$1 as ServiceWorker,
  StrictMode ,
  ReactApp ,
  
}
/*  Not a pure module */
